interface QuickButtonsProps {
  onOpenForm: () => void;
}

export default function QuickButtons({ onOpenForm }: QuickButtonsProps) {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      {/* PC Quick Buttons */}
      <div className="hidden md:flex fixed right-6 bottom-24 z-40 flex-col gap-2">
        <button
          onClick={onOpenForm}
          className="w-14 h-14 bg-primary-500 hover:bg-primary-600 rounded-lg flex flex-col items-center justify-center gap-0.5 text-white transition-all hover:scale-105 cursor-pointer"
          aria-label="관심고객 등록"
        >
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-user-add-line text-sm"></i>
          </span>
          <span className="text-[10px] font-medium">관심고객</span>
        </button>

        <a
          href="tel:1600-8869"
          className="w-14 h-14 bg-primary-500 hover:bg-primary-600 rounded-lg flex flex-col items-center justify-center gap-0.5 text-white transition-all hover:scale-105 cursor-pointer"
          aria-label="전화상담"
        >
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-phone-line text-sm"></i>
          </span>
          <span className="text-[10px] font-medium">전화상담</span>
        </a>

        <button
          onClick={scrollToTop}
          className="w-14 h-14 bg-primary-500 hover:bg-primary-600 rounded-lg flex flex-col items-center justify-center gap-0.5 text-white transition-all hover:scale-105 cursor-pointer"
          aria-label="맨 위로"
        >
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-arrow-up-line text-sm"></i>
          </span>
          <span className="text-[10px] font-medium">Top</span>
        </button>
      </div>

      {/* Mobile Bottom Bar */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-primary-950/95 backdrop-blur-md border-t border-white/10">
        <div className="flex items-center justify-around py-2 px-4">
          <button
            onClick={onOpenForm}
            className="flex flex-col items-center gap-0.5 text-white/80 hover:text-white transition-colors py-1 px-4 cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-user-add-line"></i>
            </span>
            <span className="text-[10px]">관심고객</span>
          </button>

          <a
            href="tel:1600-8869"
            className="flex flex-col items-center gap-0.5 text-white/80 hover:text-white transition-colors py-1 px-4 cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-line"></i>
            </span>
            <span className="text-[10px]">전화상담</span>
          </a>

          <button
            onClick={scrollToTop}
            className="flex flex-col items-center gap-0.5 text-white/80 hover:text-white transition-colors py-1 px-4 cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-up-line"></i>
            </span>
            <span className="text-[10px]">Top</span>
          </button>
        </div>
      </div>
    </>
  );
}